import React from "react";
import axios from 'axios';
import {API_URL, API_VERSION, API_TOKEN } from './ApiUrls';

class Axios{
  defaultOptions = {
        baseURL: `${API_URL}${API_VERSION}`,
        headers: {
          token: localStorage.getItem("token")
        }
    };

  LogoutUser=(url)=>{
    if(url.response!==undefined && !(url.response.config.headers.url).includes('dashboard')){
      console.log(url.response.config.headers.token, "401 Unauthorized Api Call")
      localStorage.clear();
      window.location.replace("/");
    }else{
      console.log(url, "401 Unauthorized Api Call")
    }
  }
  get=(url, options = {}) => {
    return axios.get(url, { ...this.defaultOptions, ...options })
    .then(res=> {return res})
    .catch(err=> {
      if(err.response.status===401){
        this.LogoutUser(err);
        return err;
      }else{
        return err;
      }
    })
  }

  post=(url, data, options = {}) => {
    return axios.post(url, data, { ...this.defaultOptions, ...options })
    .then(res=> {return res})
    .catch(err=> {
      if(err.response.status===401){
        this.LogoutUser(err);
        return err;
      }else{
        return err;
      }
    })
  }

  put=(url, data, options = {}) => {
    return axios.put(url, data, { ...this.defaultOptions, ...options })
    .then(res=> {return res})
    .catch(err=> {
      if(err.response.status===401){
        this.LogoutUser(err);
        return err;
      }else{
        return err;
      }
    })
  }

  delete=(url, options = {}) => {
    return axios.delete(url, { ...this.defaultOptions, ...options })
    .then(res=> {return res})
    .catch(err=> {
      if(err.response.status===401){
        this.LogoutUser(err);
        return err;
      }else{
        return err;
      }
    })
  }
}

export default  new Axios;
